import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import OrganizationButton from "./OrganizationButton";

import {changeCurrentOrganization} from "api/user/update";

import {SidebarContext} from "../../../../../SidebarContext";

OrganizationList.propTypes = {
    organizations: PropTypes.arrayOf(PropTypes.object)
};

function OrganizationList({organizations}) {
    const {currentOrganization, currentMember, closeSidebar} = useContext(SidebarContext);

    function changeOrganization(organization) {
        if (organization.id === currentOrganization.id) {
            return;
        }

        changeCurrentOrganization(currentMember.userId, organization.id).then(r => {
            closeSidebar();
        })
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: 'fit-content',
        }}>
            {organizations.map((organization) => (
                <OrganizationButton
                    key={organization.id}
                    organization={organization}
                    selected={currentOrganization.id === organization.id}
                    onClick={() => changeOrganization(organization)}
                />
            ))}
        </div>
    );
}

export default OrganizationList;
